import { IconProps } from "../../utils/global-types/global-types";

const CheckedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 15"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <g clipPath="url(#clip0_635_22164)">
      <path
        fill="currentColor"
        d="M7.5 0C3.365 0 0 3.365 0 7.5S3.365 15 7.5 15 15 11.635 15 7.5 11.635 0 7.5 0m4.192 5.526-4.793 4.756a.74.74 0 0 1-1.034.019L3.327 7.989a.76.76 0 0 1-.056-1.053.744.744 0 0 1 1.052-.037L6.335 8.74l4.285-4.286c.301-.3.771-.3 1.072 0 .3.3.3.77 0 1.071"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_635_22164">
        <path fill="#fff" d="M0 0h15v15H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CheckedIcon;
